/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

/* ===== Landing (Madar Galaxy) ===== */
import LandingPage from "./components/Home/landing/LandingPage";

/* ===== Pages ===== */
import Signup from "./pages/signup/Signup";
import Login from "./pages/login/Login";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import CompanyInfo from "./pages/CompanyInfo/CompanyInfo";
import ThemePlan from "./pages/themeplan/ThemePlan";
import PaymentPage from "./pages/payment/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess/PaymentSuccess";
import Forbidden403 from "./pages/Forbidden403";

/* ===== Admin ===== */
import AdminApp from "./admindashboard/AdminApp";
import AdminStoreApp from "./admin_store/AdminStoreApp";

/* ===== Store ===== */
import Stores from "./Stores/Stores";
import UnifiedStorePage from "./Stores/UnifiedStorePage";


import Theme3StorePage from "./Stores/Theme3StorePage";

/* ===== Theme Colors ===== */
const C = {
  violet: "#6A11CB",
  blue: "#2575FC",
  dark: "#0f172a",
  text: "#1e293b",
  mutetext: "#475569",
  softBg:
    "linear-gradient(145deg, rgba(106,17,203,0.05), rgba(37,117,252,0.08))",
};

export default function App() {
  const lang = localStorage.getItem("lang") || "ar";
  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.dir = dir;
  }, [dir]);

  const hostname = window.location.hostname;

  const isMainDomain =
    hostname === "madar.iq" ||
    hostname === "www.madar.iq" ||
    hostname === "localhost";

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#21003D" }}>
      <Routes>

        {/* ===== ROOT ===== */}
        <Route
          path="/"
          element={
            isMainDomain ? (
              <LandingPage />
            ) : (
              <UnifiedStorePage />
            )
          }
        />

        {/* ===== Local testing ===== */}
        <Route path="/store/:storeSlug" element={<UnifiedStorePage />} />

        {/* ===== AUTH ===== */}
        <Route path="/signup" element={<Signup C={C} />} />
        <Route path="/login" element={<Login C={C} />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/403" element={<Forbidden403 />} />

        {/* ===== ONBOARDING ===== */}
        <Route path="/company-info" element={<CompanyInfo />} />
        <Route path="/theme-plan" element={<ThemePlan />} />

        {/* ===== PAYMENT ===== */}
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/subscription-payment-result" element={<PaymentSuccess />} />
        <Route path="/payment-result" element={<PaymentSuccess />} />

        {/* ===== ADMIN ===== */}
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/admin-store/*" element={<AdminStoreApp />} />

<Route path="/test-design" element={<Theme3StorePage />} />
      </Routes>
    </div>
  );
}
